import { getTodoList,updateTodoList } from '@/api/todolist'

const state = {
}

const mutations = {
}

const actions = {
    updatetodolist({ commit }, params) {
        return new Promise((resolve, reject) => {
            updateTodoList(params).then(response => {
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },
    gettodolist({ commit }, params) {
        return new Promise((resolve, reject) => {
            getTodoList(params).then(response => {
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    }
}
export default {
    namespaced: true,
    state,
    mutations,
    actions
}
